import { startChange } from "./changeView";
import { stopAutorotation, interval, clearInternalInterval } from "./variable";

document.addEventListener("keydown", (e) => {
  stopAutorotation();
  if (!interval) {
    switch (e.code) {
      case "ArrowUp":
        startChange("up");
        break;
      case "ArrowDown":
        startChange("down");
        break;
      case "ArrowLeft":
        startChange("left");
        break;
      case "ArrowRight":
        startChange("right");
        break;
    }
  }
});
document.addEventListener("keyup", clearInternalInterval);
